import { COLORS } from '@btime/constants'
import { capitalizeIfLower, formatDate } from '@btime/helpers'
import { compose, path, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../components/helpers/StatePresenter'
import { SmallText, Title } from '../../../components/presentation/Text'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { useServiceOrderFastActionsList } from '../../../utils/actions/serviceOrders/fastList'
import { useServiceOrderState } from './_load/ServiceOrderLoader'
import { useServiceOrdersActionsList } from '../../../utils/actions/serviceOrders/list'
import { useSessionPermission } from '@btime/react-session'
import DeletedTag from '../../../components/helpers/DeletedTag'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import Icon from '../../../components/shapes/Icon'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'

const ModalHeader = () => {
  const { t } = useTranslation()
  const navigate = useNavigation()
  const { serviceOrder } = useServiceOrderState()
  const canViewServiceOrderInternalId = useSessionPermission('canViewServiceOrderInternalId')

  const options = useServiceOrdersActionsList(serviceOrder, null, undefined, {
    hide: ['seeDetails', 'cancel', 'remove', 'changeUser']
  })

  const fastActions = useServiceOrderFastActionsList(serviceOrder)

  const title = serviceOrder.name || compose(capitalizeIfLower, path(['checklist', 'name']))(serviceOrder)
  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('insertedAt'))(serviceOrder)

  return (
    <>
      <FlexGrid justify="flex-start" gutter={0.3}>
        <FlexCol flex={1}>
          {canViewServiceOrderInternalId && (
            <SmallText size="xxsmall" color={COLORS.dark3}>{`#${serviceOrder.id}`}</SmallText>
          )}
          <SmallText size="xsmall" bold color={COLORS.dark3}>
            {serviceOrder.yearlyId}
          </SmallText>
          <Title size="h4" noMargin>
            {title}
          </Title>
          <SmallText color={COLORS.dark3}>
            {t('createdAt')} {createdAt}
          </SmallText>
        </FlexCol>
        <FlexCol flex={1}></FlexCol>

        <FlexCol>
          <DeletedTag entity={serviceOrder} />
        </FlexCol>
        <FlexCol>
          <RefetchingIndicator />
        </FlexCol>

        {!serviceOrder.deleted && (
          <>
            {fastActions.map(action => (
              <>
                <FlexCol key={action.label}>
                  <IconText iconLeft={action.icon} color="dark3" bold {...action} noWrap />
                </FlexCol>
                <Separator vertical />
              </>
            ))}

            <FlexCol>
              <DropdownLink
                fromRight
                options={options}
                actionContent={<Icon name="BsThreeDotsVertical" ize="1.4rem" />}
                t={t}
              />
            </FlexCol>
          </>
        )}
      </FlexGrid>

      <Separator weight={2} />

      <TabsMenu t={t} />
    </>
  )
}

export default ModalHeader
